import React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';

import { GetResourceValue } from '../../../../utils/game-document';
import { GameDocumentContext } from '../../../../contexts/game-document';
import { TaskContentAnswer } from '../../../../types/game-document/entities/task-content';

const AnswerCheckbox: React.FC<{ answers: TaskContentAnswer[] }> = ({
  answers
}) => {
  const [state] = React.useContext(GameDocumentContext);

  const options = answers.map((answer) => ({
    answerResId: answer.answerResId,
    description: GetResourceValue(state.gameDocument!, answer.answerResId) ?? ''
  }));

  return (
    <div id={'answer-checkbox'}>
      {options.map((option) => (
        <div
          className={
            'd-flex flex-row justify-content-center align-items-center card border border-2 w-100 my-2 border-dark'
          }
          key={option.answerResId}>
          <div className={'card-body flex-grow-1'}>
            <Checkbox
              className={'input-checkbox'}
              size={'large'}
              label={option?.description}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnswerCheckbox;
